import saleResidentialObjectTypes from '../../../scripts/enums/sale-residential-object-types.js';
import rentResidentialObjectTypes from '../../../scripts/enums/rent-residential-object-types.js';
import leaseTermType from '../../../scripts/enums/lease-term-type';
import dailyRentResidentialObjectTypes from '../../../scripts/enums/daily-rent-residential-object-types.js';
import
  commercialObjectTypes, {
  typesWithCoworking,
} from '../../../scripts/enums/commercial-object-types';
import { isNewOffer } from '../../../scripts/services/ad-state.service';
import { trackChangeType } from './ad-type.tracking';
import { isBaseAndProfiFrozen } from '../../../../../shared/utils';
import { getBarTitle } from '../../../../../shared/utils/offer/getBarTitle';

export const allowedCategories = [
  'flatSale', 'newBuildingFlatSale', 'roomSale', 'flatShareSale',
  'houseSale', 'cottageSale', 'townhouseSale', 'houseShareSale', 'apiService'
];

export default function (
  $scope, $timeout, categoryService, popupService, adStateService, analyticsService, hiddenBaseService,
  homeownerService, userService, addFormLayoutService, deviceService,
  config, geoService, adFieldsCleaningService, coworkingService,
) {
  'ngInject';

  const userCanPublishCoworking = coworkingService.userCanPublishCoworking();
  this.oldObjectType = undefined;

  this.isMobile = deviceService.isMobile;

  let {
    userType: userTypeScoped,
    userCanPublishThisOfferAsHomeowner: canPublishAsHomeownerScoped,
    userCanPublishThisOfferAsCommercialOwner: canPublishAsCommercialOwnerScoped,
  } = homeownerService;

  // и нам известно явно, что это соб или агент, установим переключатель в соответствующее положение
  if (userTypeScoped === 'homeowner' || userTypeScoped === 'specialist') {
    this.ad.isByHomeowner = userTypeScoped === 'homeowner';
  }

  let isCommercialOwner = userService.isCommercialOwner();
  // для коммерческой собами являются управляющая компания или отдел аренды
  if (canPublishAsCommercialOwnerScoped && isCommercialOwner) {
    this.ad.isByCommercialOwner = isCommercialOwner;
  }

  // Вычисляем соб ли пользователь (если он соб жилой и/или коммерческой)
  this.isByOwner = this.ad.isByHomeowner || this.ad.isByCommercialOwner;

  $scope.getVisibilityTooltipHtml = () => {
    const isTariffsFrozen = isBaseAndProfiFrozen({ config, geoService });

    return `
      Вы можете разместить неликвидные объекты<br/>
      бесплатно и сделать их видимыми только для других<br/>
      агентов на ${isTariffsFrozen ? 'Тарифе с подпиской' : 'тарифах Базовый и Профи'}.
      <a target="_blank" href="https://www.cian.ru/help/cian-for-professionals/37854/">Подробнее</a>
    `;
  };

  // При очистке формы, установим переключатель соб/агент в дефолтное значение
  $scope.$on('addform.clear', (e, ad) => {
    // ad берем из broadcast, т.к. в add-form.controller:84 именно эта ad присваивается addFormService.ad
    // Т.е. если вместо ad.isByHomeowner указать this.ad.isByHomeowner, он будет перезатерт ad из параметра
    userTypeScoped = homeownerService.userType;
    if (userTypeScoped === 'homeowner' || userTypeScoped === 'specialist') {
      ad.isByHomeowner = homeownerService.userType === 'homeowner';
    }

    isCommercialOwner = userService.isCommercialOwner();
    if (canPublishAsCommercialOwnerScoped && isCommercialOwner) {
      ad.isByCommercialOwner = isCommercialOwner;
    }

    this.isByOwner = this.ad.isByHomeowner || this.ad.isByCommercialOwner;
  });

  // Следим за измененими в homeownerService
  $scope.$watchGroup([
    () => homeownerService.userType,
    () => homeownerService.userCanPublishThisOfferAsHomeowner,
    () => homeownerService.userCanPublishThisOfferAsCommercialOwner,
  ], ([newUserType, newUserCanPublishThisOfferAsHomeowner, newUserCanPublishThisOfferAsCommercialOwner]) => {
    userTypeScoped = newUserType;
    canPublishAsHomeownerScoped = newUserCanPublishThisOfferAsHomeowner;
    canPublishAsCommercialOwnerScoped = newUserCanPublishThisOfferAsCommercialOwner;
  });

  analyticsService.addFormStep1();

  const coworkingSubTypes = coworkingService.getCoworkingSubTypes();

  const saleResidentialObjectTypesGroups = [saleResidentialObjectTypes.slice(0, 4), saleResidentialObjectTypes.slice(4)];
  const rentResidentialObjectTypesGroups = [rentResidentialObjectTypes.slice(0, 3), rentResidentialObjectTypes.slice(3)];
  const commercialObjectTypesGroups = [commercialObjectTypes.slice(0, 5), commercialObjectTypes.slice(5)];
  const coworkingSubTypesGroups = [coworkingSubTypes.slice(0, 5)];

  const commercialObjectTypesGroupsWithCoworking = [typesWithCoworking.slice(0, 5), typesWithCoworking.slice(5)];

  this.isExpanded = true;
  this.isHomeownerTooltipOpenned = false;
  this.barTitle = '';

  this.accountTypes = [{
    value: true,
    text: 'Собственник',
    disabled: false,
  }, {
    value: false,
    text: 'Агент',
  }];

  this.propertyTypeItems = [
  {
    value: 'residential',
    text: 'Жилая',
    disabled: false,
  }, {
    value: 'commercial',
    text: 'Коммерческая',
    disabled: false,
  }];

  this.rentDurationTermTypes = [...leaseTermType, { value: "short", text: "Посуточно" }];

  const longTermValues = leaseTermType.map(item => item.value);

  const getRentDuration = () => {
    return this.rentDuration === 'long' && this.ad.bargainTerms['leaseTermType'] ?
      this.ad.bargainTerms['leaseTermType'] :
      this.rentDuration;
  };

  this.rentDuration = getRentDuration();

  $scope.$watch(() => this.rentDuration, (rentDuration, oldRentDuration) => {
    if (rentDuration === oldRentDuration) return;

    this.rentDuration = getRentDuration();
  });

  this.coworkingSubTypes = {
    all: coworkingSubTypes,
    groups: coworkingSubTypesGroups,
  };

  if (this.dealType === 'rent' && this.ad.coworkingOfferType) {
    this.objectType = 'coworking';
    this.objectSubType = this.ad.coworkingOfferType;
  }

  const getObjectTypes = () => {
    if (this.propertyType === 'commercial') {
      if (this.dealType === 'rent') {
        return {
          all: typesWithCoworking,
          groups: commercialObjectTypesGroupsWithCoworking,
        };
      }

      return {
        all: commercialObjectTypes,
        groups: commercialObjectTypesGroups,
      };
    } else if (this.propertyType === 'residential' && this.dealType === 'sale') {
      return {
        all: saleResidentialObjectTypes,
        groups: saleResidentialObjectTypesGroups,
      };
    } else if (this.propertyType && longTermValues.indexOf(this.rentDuration) >= 0) {
      return {
        all: rentResidentialObjectTypes,
        groups: rentResidentialObjectTypesGroups,
      };
    } else if (this.propertyType && this.rentDuration === 'short') {
      return {
        all: dailyRentResidentialObjectTypes,
      };
    }
    return null;
  };

  this.isAccountTypeAvailable = () => !userService.isAuthenticated ||
    canPublishAsHomeownerScoped ||
    (canPublishAsCommercialOwnerScoped && !isCommercialOwner) ||
    userTypeScoped === 'homeowner';

  this.closeHomeownerTooltip = () => {
    this.isHomeownerTooltipOpenned = false;
    $scope.$apply();
  };

  const clearCoworkingChanges = () => {
    this.ad.coworkingOfferType = undefined;
    this.objectSubType = undefined;
  };

  const setCategoryOfficeRent = () => {
    this.category = 'officeRent';
  };

  this.onChange = (level, init) => {
    if (!init && level !== 'isByOwner') {
      adStateService.setCategoryChanged(true);
    }

    if (!this.ad.bargainTerms) {
      this.ad['bargainTerms'] = {};
    }

    if (this.isMobile) {
      this.isUseAnotherVerticalShow = false;
    }

    switch (level) {
      case 'dealType' :
        this.rentDuration = null;
        this.propertyType = null;
        this.objectType = null;
        trackChangeType('dealtype_select', this.dealType);
        break;
      case 'rentDuration' :
        if (!this.ad.id) {
          this.propertyType = null;
        }
        this.objectType = null;
        if (this.rentDuration) {
          trackChangeType('renttype_select', this.rentDuration);
        }
        break;
      case 'propertyType' :
        this.objectType = null;
        this.ad.coworkingOfferType = undefined;
        this.objectSubType = undefined;

        if (this.propertyType) {
          // для публикации заявке не может стоять сразу два флага
          // поэтому определяем по типу недвиги
          this.ad.isByCommercialOwner = canPublishAsCommercialOwnerScoped
            && this.propertyType === 'commercial'
            && this.isByOwner;
          this.ad.isByHomeowner = !isCommercialOwner && this.propertyType === 'residential' && !!this.isByOwner;

          trackChangeType('offertype_select', this.propertyType);
        }
        break;
      case 'subType' :
        this.ad.coworkingOfferType = undefined;
        this.objectSubType = undefined;
        // обработка кастомнога клика по коворкингам для совмещения со сбросом формы
        if (init && init.isCoworking) {
          if (!this.oldObjectType) {
            // переключение без сборса формы
            this.objectType = 'coworking';
          } else {
            // переключение со сбросом формы
            adStateService.setCategoryChanged(true);
            this.objectType = null;

            $timeout(() => {
              this.objectType = 'coworking';
            });
          }
        }
        break;
    }

    if (this.dealType === 'rent') {
      this.rentDurationShown = true;
      this.propertyTypeShown = !!this.rentDuration;
      if (this.rentDuration === 'short') {
        this.propertyType = 'residential';
        // Убираем заглушку, т.к. посуточная аренда не может быть коммерческой
        this.isUseAnotherVerticalShow = false;
      } else {
        if (longTermValues.indexOf(this.rentDuration) >= 0) {
          this.ad.bargainTerms['leaseTermType'] = this.rentDuration;
        }
      }
    } else {
      this.rentDurationShown = false;
      this.propertyTypeShown = !!this.dealType;
      this.rentDuration = null;
    }
    this.objectTypes = getObjectTypes();
    // try to save object type when user changes selection in other controls
    const selectedObjectType = this.objectTypes && this.objectTypes.all.find(objectType => {
        return objectType.key === this.objectType;
      });
    this.objectType = selectedObjectType && selectedObjectType.key;

    if (this.objectType !== 'coworking') {
      if (this.category === 'officeRent') {
        this.category = undefined;
        setTimeout(() => {
          this.category = categoryService.getCategoryByInfo(this.dealType, this.objectType, this.rentDuration);
        }, 0);
      } else {
        this.category = categoryService.getCategoryByInfo(this.dealType, this.objectType, this.rentDuration);
      }
    }

    if (!allowedCategories.includes(this.category) && isNewOffer) {
      this.ad.bargainTerms.mortgageAllowed = undefined;
    }

    if (this.dealType && this.objectType && this.propertyType) {
      const selectedObjectSubType = this.coworkingSubTypes.all.find(objectType => {
        return objectType.key === this.objectSubType;
      });
      this.objectSubType = selectedObjectSubType && selectedObjectSubType.key;

      // Если выбран объект Объект коворкинг + выбран Новый тип Гибкий офис
      if (
        this.objectSubType &&
        this.dealType === 'rent' &&
        this.objectType === 'coworking' &&
        this.propertyType === 'commercial'
      ) {
        // Удаляем ненужное в форме коворкинга поле
        delete this.ad.conditionType;

        coworkingService.initializeCoworkingObject();

        this.barTitle = getBarTitle(this.dealType, selectedObjectSubType.genitiveName, this.rentDuration);

        coworkingService.changeCoworkingOfferType(this.objectSubType);

        if (this.category === 'officeRent') {
          this.category = undefined;

          setTimeout(() => {
            setCategoryOfficeRent();
          }, 0);
        } else {
          setCategoryOfficeRent();
        }

        this.isExpanded = false;
      } else if (this.objectType !== 'coworking') {
        this.barTitle = getBarTitle(this.dealType, selectedObjectType.genitiveName, this.rentDuration);

        this.isExpanded = false;

        clearCoworkingChanges();
      }

      this.ad.categoryName = this.barTitle;
    } else {
      this.isExpanded = true;
    }

    if (!this.objectType) {
      if (!this.showMessage) {
        this.showMessageTimer = $timeout(() => {
          this.showMessage = true;
        }, 30000);
      }
    } else {
      if (this.showMessageTimer) {
        $timeout.cancel(this.showMessageTimer);
      }
      this.showMessage = false;
    }

    if (this.isAccountTypeAvailable()) {
      // отключаем кнопку если выбраны новостройки
      const disableOwnerChoice = this.category === 'newBuildingFlatSale';

      // отключаем кнопку, если у спеца нет возможности публиковаться как соб жилой
      const disableHomeownerChoice = userTypeScoped === 'specialist' &&
        this.propertyType === 'residential' &&
        !canPublishAsHomeownerScoped;

      // отключаем кнопку, если для коммерческой недоступна опция
      const disabledCommercialOwnerChoice = this.propertyType === 'commercial' && !canPublishAsCommercialOwnerScoped;

      // при выключенном флаге на бэке, поле canPublishAsCommercialOwnerScoped не приходит
      // для обратной совместимости функционала обрабатываем отдельный кейс для такого случая
      // рефакторинг этой фукнкциональности будет проводится в рамках CD-85875
      const disabledCommercialOwnerFunctionality = this.propertyType === 'commercial'
        && canPublishAsCommercialOwnerScoped == null;

      const userTypeElement = Array.isArray(this.accountTypes) && this.accountTypes.find(type => type.value === true);

      if (userTypeElement) {
        userTypeElement.disabled =
        ((disableOwnerChoice || disabledCommercialOwnerChoice || disableHomeownerChoice) && userService.isAuthenticated)
        || (!userService.isAuthenticated && disabledCommercialOwnerFunctionality);
      }

      if (disableHomeownerChoice && userService.isAuthenticated) {
        this.ad.isByHomeowner = false;
      }

      if (disabledCommercialOwnerChoice && userService.isAuthenticated ||
          disabledCommercialOwnerFunctionality && !userService.isAuthenticated) {
        this.ad.isByCommercialOwner = false;
      }

      // если хотя бы один из кейсов срабатывает, то переключаем с соба на агента
      // для коммерческой не важно авторизован пользак или нет
      if (
        ((disableOwnerChoice || disabledCommercialOwnerChoice || disableHomeownerChoice) && userService.isAuthenticated)
        || (!userService.isAuthenticated && disabledCommercialOwnerFunctionality)
      ) {
        this.isByOwner = false;
      }
    }

    // На вебе кадастровый номер проверяем только для данных категорий
    const availableTypes = [
      'dailyFlatRent',
      'flatRent',
      'flatSale',
      'flatShareSale',
      'roomRent',
      'roomSale',
      'bedRent',
    ];
    if (!availableTypes.includes(this.category)) {
      delete this.ad.homeOwner;
    }

    if (!level && !!this.objectType) {
      trackChangeType('objecttype_select', this.objectType);
    }

    if (!level && !!this.objectSubType) {
      coworkingService.trackCoworkingChangeSubType(this.objectSubType);
    }

    if (level === 'isByOwner') {
      if (this.isByOwner) {
        this.isHomeownerTooltipOpenned = true;
      } else {
        this.isHomeownerTooltipOpenned = false;
      }

      // проверяем тип недвиги и возможность публиковаться как соб
      // и маппим значение на соотвествующий флаг публикации от соба
      this.ad.isByCommercialOwner = canPublishAsCommercialOwnerScoped
        && this.propertyType === 'commercial'
        && this.isByOwner;

      this.ad.isByHomeowner = this.propertyType === 'residential' && this.isByOwner;

      trackChangeType('acctype_select', this.isByOwner ? 'user' : 'agent');
      addFormLayoutService.setLayout();
      adFieldsCleaningService.onOwnerTypeChange();
    }

    this.oldObjectType = this.objectType;
  };

  const search = categoryService.getSearch();

  if (!this.dealType && search.dealType) {
    this.dealType = search.dealType;
  }

  if (!this.rentDuration && search.rentDuration) {
    this.rentDuration = search.rentDuration;
  }

  if (!this.propertyType && search.propertyType) {
    this.propertyType = search.propertyType;
  }

  if (!this.objectType && search.objectType) {
    this.objectType = search.objectType;
  }

  this.onChange(undefined, true);

  // При очистке формы, меняется объект и вызывается метод onChange
  $scope.$watch(() => this.ad, this.onChange);

  this.showRules = () => popupService.openPopup('adRules');

  this.isHiddenBaseAvailable = () => hiddenBaseService.isAvailable();

  this.onChangeHiddenBase = () => {
    hiddenBaseService.onChangeSwitcherHiddenBase(this.ad.isInHiddenBase);
  };

  this.isAccountTypeSelected = () => this.isByOwner != null;

  this.openHomeOwnerHintModal = () => popupService.openPopup('homeownerHint');

  this.getAccountTypeDefaultValue = () => {
    /*
    Если есть категория, значит есть или активный черновик или редактирование, есть категория
    */
    if (this.ad.category) {
      return false;
    }
  };

  // Обработчик клика по кнопке "Я хочу стать агентом"
  this.switchToAgent = () => {
    this.ad.isByHomeowner = false;
    userTypeScoped = 'specialist';
    homeownerService.isChangeToAgent = true;
  };

  this.isShowObjectType = () => {
    return this.objectType === 'coworking' &&
      this.coworkingSubTypes &&
      this.rentDuration !== 'short' &&
      !this.isUseAnotherVerticalShow &&
      userCanPublishCoworking;
  };

  this.isShowAddCoworking = () => {
    return this.objectType === 'coworking' &&
      this.coworkingSubTypes &&
      this.rentDuration !== 'short' &&
      !this.isUseAnotherVerticalShow &&
      !userCanPublishCoworking;
  };

  this.objectTypeChangeWrapperFn = (objectType) => {
    let init;

    if (objectType.key === 'coworking') {
      init = { isCoworking: true };
    }

    this.onChange('subType', init);
  };
};
